import { bind } from 'bind-decorator';
import React from 'react';
import { colours } from '../../../../styles/colours';

interface IProps {
  value?: string;
  inline?: boolean;

  onClick: () => void;
}

class Label extends React.Component<IProps> {
  shouldComponentUpdate(nextProps: IProps): boolean {
    const { props } = this;

    if (props.inline !== nextProps.inline) {
      return true;
    }

    if (props.value !== nextProps.value) {
      return true;
    }

    return false;
  }

  render() {
    if (!!this.props.inline) {
      return null;
    }

    return (
      <span
        style={{ color: colours.lightBlue, fontSize: 16, display: 'block' }}
        onClick={this.onClick}
      >
        {this.props.value}
      </span>
    );
  }

  @bind
  private onClick(): void {
    this.props.onClick();
  }
}

export default Label;
